export enum StepId {
  LandingPage = 'LANDING_PAGE',
  SelectStoreType = 'SELECT_STORE_TYPE',
  SelectSellingType = 'SELECT_SELLING_TYPE',
  SelectCategory = 'SELECT_CATEGORY',
  SelectCatalogSize = 'SELECT_CATALOG_SIZE',
  SelectTemplate = 'SELECT_TEMPLATE',
  SelectSiteName = 'SELECT_SITE_NAME',
  SiteSetup = 'SITE_SETUP',
  SiteReady = 'SITE_READY',
  CurrentPlatform = 'CURRENT_PLATFORM',
  CreateProductUpload = 'CREATE_PRODUCT_UPLOAD',
  CreateProductForm = 'CREATE_PRODUCT_FORM',
}

export enum ActionId {
  RedirectToLogin = 'REDIRECT_TO_LOGIN',
  RedirectToUpgradePlan = 'REDIRECT_TO_UPGRADE_PLAN',
  RedirectToDashboard = 'REDIRECT_TO_DASHBOARD',
  PlatformDomainToSiteName = 'PLATFORM_DOMAIN_TO_SITE_NAME',
  SetTemplateSlug = 'SET_TEMPLATE_SLUG',
}
